import { render } from "./SampleInformationTabs.vue?vue&type=template&id=fcb069f0&scoped=true"
import script from "./SampleInformationTabs.vue?vue&type=script&lang=js"
export * from "./SampleInformationTabs.vue?vue&type=script&lang=js"

import "./SampleInformationTabs.vue?vue&type=style&index=0&id=fcb069f0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fcb069f0"]])

export default __exports__